import type { InvoiceResponse } from '../../api/types';
import { invoiceMoney } from './invoiceCopyText';
import { formatIstDate, formatIstDateTime } from '../payments/paymentDates';
import { orderReference } from './orderReference';
import { formatGstState } from './gstStates';

// Shared frozen-data mapping for the reference's landscape web/print/vector PDF grid.
export const consignmentHead = [
  'DNM LR No.',
  'LR Date',
  'Truck No.',
  'No of Boxes',
  'Consignee',
  'Loading Point',
  'Item Name',
  'Destination',
  'Consignor Inv No',
  'Freight Amount',
  'GST Charged',
  'Total',
];
export const consignmentWidths = [19, 19, 21, 14, 23, 23, 17, 20, 38, 24, 24, 32];
export const invoiceGeometry = {
  width: 274,
  left: 6,
  top: 5,
  right: 17,
  bottom: 12,
};
const present = (value: string | number | null | undefined) =>
  value == null || value === '' ? 'Not provided' : String(value);
export function consignmentRow(invoice: InvoiceResponse) {
  const s = invoice.snapshot,
    r = s.references;
  return [
    present(r?.lrNumber),
    r?.lrDate ? formatIstDate(r.lrDate) : 'Not provided',
    `${present(s.trip.vehicleNumber)}\n${orderReference(invoice.shipmentId)}`,
    present(r?.packages),
    present(r?.consignee),
    present(s.trip.pickupCity),
    present(r?.itemName),
    present(s.trip.dropCity),
    present(r?.consignorInvoiceNo),
    invoiceMoney(s.tax.taxableAmount),
    invoiceMoney(s.tax.totalTaxAmount),
    invoiceMoney(s.tax.grandTotal),
  ];
}
export function invoiceDisclosures(invoice: InvoiceResponse) {
  const s = invoice.snapshot;
  const result = [
    `${orderReference(invoice.shipmentId)} · Place of Supply: ${formatGstState(s.placeOfSupply)} · Reverse charge: ${s.tax.mode === 'RCM' ? 'Yes' : 'No'}${s.taxTreatment === 'EXEMPT' ? ' · GST exempt' : ''}`,
  ];
  result.push(
    `Pickup Date: ${s.trip.pickupDate ? formatIstDate(s.trip.pickupDate) : 'Not provided'} · Delivery Date: ${s.trip.deliveredDate ? formatIstDate(s.trip.deliveredDate) : 'Not provided'} · Buyer PAN: ${s.buyer.pan ?? 'Not provided'}`,
  );
  if (s.taxTreatment === 'EXEMPT') {
    result.push(`GST exempt supply. Reason: ${s.exemption?.reason ?? 'Not provided'}`);
    if (s.exemption?.reference) result.push(`Exemption reference: ${s.exemption.reference}`);
    result.push(
      `Issued by ${s.exemption?.issuedByName ?? `Staff #${s.exemption?.issuedByOpsUserId ?? 'unavailable'}`} at ${formatIstDateTime(s.exemption?.issuedAt ?? invoice.createdAt)} IST`,
    );
  }
  return result;
}
